import { render, staticRenderFns } from "./dormAccessDialog.vue?vue&type=template&id=31915e12&"
import script from "./dormAccessDialog.vue?vue&type=script&lang=js&"
export * from "./dormAccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports